"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCollectionQueryParameters = void 0;
const stdlib_core_1 = require("@groupby/stdlib-core");
const boolean_1 = require("@groupby/stdlib-core/boolean");
const number_1 = require("@groupby/stdlib-core/number");
const sort_1 = require("../sort");
const cel_1 = require("@groupby/enrich-criteria/cel");
function parseCollectionQueryParameters(params) {
    var _a, _b, _c;
    return {
        filter: stdlib_core_1.optionalize(cel_1.parse)(params.filter),
        page: {
            limit: ((_a = params.page) === null || _a === void 0 ? void 0 : _a.limit) === 'max' ? params.page.limit : stdlib_core_1.optionalize(number_1.strictParseInt)((_b = params.page) === null || _b === void 0 ? void 0 : _b.limit),
            offset: stdlib_core_1.optionalize(number_1.strictParseInt)((_c = params.page) === null || _c === void 0 ? void 0 : _c.offset),
        },
        sort: stdlib_core_1.optionalize(sort_1.parse)(params.sort),
        includeTotal: stdlib_core_1.optionalize(boolean_1.strictParseBool)(params.includeTotal),
    };
}
exports.parseCollectionQueryParameters = parseCollectionQueryParameters;
//# sourceMappingURL=parse-collection-query-parameters.js.map